import Head from 'next/head'
import styles from '../../styles/index.module.css'
import Script from 'next/script'

export default function Home() {

  return (
    <>
      <Head>
        <title>Personal Trainer Service Terms For Clients | StringsSG</title>
        <meta charSet="utf-8"/>
        <meta httpEquiv="X-UA-Compatible" content="IE=edge"/>
        <meta name="viewport" content="width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no"/>
        <meta name="description" content="Personal Trainer Service Terms For Clients - Payment Details, Termination, Rescheduling & Cancellation, Client Health Declaration, Liability Waiver, Package Extension Policy, Non-Solicitation & Penalties, Trainer Assignment & Substitution, Code of Conduct & Zero Tolerance Policy, Data Protection (PDPA)"/>
        <meta name="keywords" content="personal trainer, fitness training, gym training, personal training packages, fitness services, health and wellness, personal trainer terms, client terms"/>
        <meta name="author" content="StringsSG"/>
        <meta name="google-site-verification" content="JAjj5vAc8Xxrh4idRAchZhYR6rwxWPAk3vxMdx-dwVQ" />
        <meta property="og:url"   content="https://www.stringssg.com/terms/personal-trainer-service-terms-for-clients" />
        <meta property="og:type"   content="website" />
        <meta property="og:title"    content={`Personal Trainer Service Terms For Clients | StringsSG`}/>
        <meta property="og:description" content="Personal Trainer Service Terms For Clients - Payment Details, Termination, Rescheduling & Cancellation, Client Health Declaration, Liability Waiver, Package Extension Policy, Non-Solicitation & Penalties, Trainer Assignment & Substitution, Code of Conduct & Zero Tolerance Policy, Data Protection (PDPA)" />
        <meta property="og:image"  content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:image" content="https://stringssg-assets.s3-ap-southeast-1.amazonaws.com/static/Google-icon.png" />
        <meta name="twitter:site" content="@stringssg"/> 
        <meta name="twitter:url" content="https://www.stringssg.com/terms/personal-trainer-service-terms-for-clients"/>
        <meta name="twitter:title" content={`Personal Trainer Service Terms For Clients | StringsSG`}/> 
        <meta name="twitter:description" content="Personal Trainer Service Terms For Clients - Payment Details, Termination, Rescheduling & Cancellation, Client Health Declaration, Liability Waiver, Package Extension Policy, Non-Solicitation & Penalties, Trainer Assignment & Substitution, Code of Conduct & Zero Tolerance Policy, Data Protection (PDPA)"/>
        <link rel="icon" href="/favicon.ico" />
        <link rel="canonical" href="https://www.stringssg.com/terms/personal-trainer-service-terms-for-clients"/>
        </Head>
            <div className="max-w-4xl mx-auto py-4"> 
                <div id="personal-trainer-terms" className='text-gray-500 p-4 space-y-6 py-8 leading-7 text-sm'>
                    <h1 className='text-xl uppercase'>Personal Trainer Service Terms For Clients</h1>
                    
                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>1. Payment Details</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>Invoice and receipt can be accessed under Account &gt; Payment & Receipts &gt; Receipt in the Client's StringsSG account.</li>
                            <li>Full payment is required before the commencement of the first session.</li>
                            <li>All payments are non-refundable except as expressly stated in this Agreement.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>2. Termination</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>Either party may terminate this Agreement by providing written notice with a seven (7) day notice period.</li>
                            <li>If termination is initiated by the Service Provider, the Client shall be refunded for all outstanding, unused sessions.</li>
                            <li>If termination is initiated by the Client, no refund shall be issued for unused sessions.</li>
                            <li>In the event the Client provides certified medical proof of inability to continue training, the Service Provider may, at its sole discretion, offer a partial refund or credit.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>3. Rescheduling & Cancellation</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>The Client must provide at least 24 hours' notice to reschedule a session.</li>
                            <li>Sessions cancelled or missed without such notice shall be forfeited and deemed delivered.</li>
                            <li><strong>Late Arrival Policy:</strong> Sessions will begin and end at the scheduled time. If the Client arrives late, the session will conclude at the original end time. No extension or credit will be provided for time lost due to Client delay.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>4. Client Health Declaration</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>The Client confirms that they have no medical conditions that would prevent safe participation in exercise.</li>
                            <li>Any conditions relating to the heart, lungs, bones, or vital organs must be fully disclosed to the trainer.</li>
                            <li>The Client is responsible for obtaining medical clearance prior to commencing training, if necessary.</li>
                            <li>The Service Provider shall not be liable for any injury, loss, or damage arising from undisclosed or misrepresented medical conditions.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>5. Liability Waiver</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>The Client acknowledges that physical exercise carries inherent risks, including but not limited to muscle strain, falls, or cardiovascular incidents.</li>
                            <li>The Client agrees to participate in training sessions at their own risk.</li>
                            <li>The Service Provider and its trainers shall not be liable for injuries, accidents, or damages sustained during training, except where caused by proven negligence or willful misconduct.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>6. Package Extension Policy</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>All unused sessions shall expire at the end of the validity period and cannot be carried forward.</li>
                            <li><strong>Request Process:</strong> Formal requests for package extensions must be emailed to support@stringssg.com.</li>
                            <li><strong>Documentation:</strong> Requests must include a valid reason and supporting documents (e.g., Travel tickets for vacations or Medical Certificates for health reasons).</li>
                            <li><strong>Minimum Duration:</strong> Extensions are only applicable for absences with a minimum duration of ten (10) consecutive days. Absences shorter than this (e.g., 2 days) are not eligible for extension.</li>
                            <li><strong>Approval:</strong> StringsSG reviews all applications individually and reserves the right to approve or decline requests at its sole discretion. Verbal commitments from trainers or staff are not binding.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>7. Non-Solicitation & Penalties</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li><strong>Restriction:</strong> The Client agrees not to privately engage, hire, or compensate any trainer provided by StringsSG outside of this Agreement during the term of the package and for a period of twelve (12) months following its completion.</li>
                            <li><strong>Penalty (Liquidated Damages):</strong> In the event of a breach of this clause, the Client shall be liable to pay StringsSG a penalty fee of S$3,000 (or the equivalent of the total package value, whichever is higher) as a genuine pre-estimate of lost administrative costs and business placement fees.</li>
                            <li><strong>Legal Action:</strong> StringsSG reserves the right to take further legal action to recover losses or seek an injunction to prevent continued unauthorized engagement.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>8. Trainer Assignment & Substitution</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>StringsSG reserves the right to substitute trainers at its sole discretion due to logistical or operational needs, particularly in instances where a trainer is no longer able to serve the Client's specific location.</li>
                            <li>All substitute trainers are experienced, certified, and vetted to ensure a consistent standard of service.</li>
                            <li>A change in trainer does not entitle the Client to a refund, credit, or package cancellation.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>9. Code of Conduct & Zero Tolerance Policy</h2>
                        <ul className='pl-4 list-disc space-y-2'>
                            <li>StringsSG maintains a zero-tolerance policy regarding inappropriate behaviour, including but not limited to sexual harassment, unwelcome advancements, or racist attacks.</li>
                            <li>Any such conduct will result in the immediate cancellation of the package without any refund or compensation for unused sessions.</li>
                        </ul>
                    </div>

                    <div className='space-y-2'>
                        <h2 className='font-bold text-lg'>10. Data Protection (PDPA)</h2>
                        <p>
                            StringsSG collects and uses the Client's personal and health data solely for the purpose of providing and managing training services in accordance with the Singapore Personal Data Protection Act.
                        </p>
                    </div>

                    <div className='bg-gray-100 p-4 rounded-lg mt-6'>
                        <p className='text-sm text-gray-600'>
                            This document is electronically generated and does not require a physical signature.
                        </p>
                    </div>
                </div>
            </div>
        <Script 
          id="google-tagmanager-new"
          src="https://www.googletagmanager.com/gtag/js?id=G-QD1HGGHDYJ"
          strategy="lazyOnload"
          onLoad={() => {              
            window.dataLayer = window.dataLayer || [];
            function gtag(){dataLayer.push(arguments);}
            gtag('js', new Date());
          
            gtag('config', 'G-QD1HGGHDYJ');
          }} 
        />
        <Script id="facebook-tracking" strategy="lazyOnload">
          {`!function(f,b,e,v,n,t,s)
					  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
					  n.callMethod.apply(n,arguments):n.queue.push(arguments)};
					  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
					  n.queue=[];t=b.createElement(e);t.async=!0;
					  t.src=v;s=b.getElementsByTagName(e)[0];
					  s.parentNode.insertBefore(t,s)}(window, document,'script',
					  'https://connect.facebook.net/en_US/fbevents.js');
					  fbq('init', '128634041116395');
					  fbq('track', 'PageView');`}
        </Script>
    </>
  )
}